<template>
  <div
    class="container-fluid p-2 pt-3"
    style="
      scrollbar-width: none;
      -ms-overflow-style: none;
      background-color: #000;
      background-image: url('https://storage.googleapis.com/spacetech2/syy/Log-in%20background.png');
      height: 100vh;
      overflow-y: scroll;
      background-size: cover;
      padding-bottom: 15rem;
      background-attachment: fixed;
    "
  >
    <div style="height: 115vh">
      <!-- <div class="my-3 d-flex flex-wrap px-0 mx-0">
            <button class="detail-button w-auto text-nowrap mx-1 my-1">ALL</button>
            <button class="detail-button w-auto text-nowrap my-1">NEW MEMBER</button>
            <button class="detail-button w-auto text-nowrap mx-1 my-1">LIVE CASINO</button>
            <button class="detail-button w-auto text-nowrap my-1">LIVE CASINO</button>
            <button class="detail-button w-auto text-nowrap mx-1 my-1">LIVE CASINO</button>
            <button class="detail-button w-auto text-nowrap my-1">LIVE CASINO</button>
          </div> -->
      <div class="col-12 px-1 mb-5 pb-5">
        <div
          class="mt-2 mb-3"
          style="
            box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            box-shadow: none;
            background: #242424;
            border-radius: 0.5rem;
          "
          v-for="(promotion, proIndex) in promotions"
          :key="proIndex"
        >
          <a href="">
            <!-- https://t.me/hulk333vip -->
            <img
              :src="promotion.image"
              style="
                border-top-left-radius: 0.5rem;
                border-top-right-radius: 0.5rem;
                width: 100%;
              "
              alt=""
            />
          </a>
          <div class="px-3 py-2 d-flex justify-content-between">
            <h3 class="text-white my-auto">
              <!-- <picture class="mr-2">
                      <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.webp" type="image/webp">
                      <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.gif" alt="💸" width="25" height="25">
                    </picture> -->
              {{ promotion.title }}
              <!-- <picture class="ml-2">
                      <source srcset="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.webp" type="image/webp">
                      <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.gif" alt="💸" width="25" height="25">
                    </picture> -->
            </h3>
            <button
              class="detail-button text-white col-3"
              @click="promotionIndex(proIndex)"
            >
              {{ $t("detail") }}
            </button>
          </div>

          <van-overlay
            :show="selectedPromotion === proIndex"
            @click="selectedPromotion = null"
          >
            <div class="wrapper col-12 d-flex h-100vh">
              <div
                class="col-11 card mx-auto my-auto py-4 px-3"
                style="background: #202124 !important"
              >
                <h2 class="pb-3" style="color: #fff">{{ promotion.title }}</h2>
                <span style="color: #fff" v-html="promotion.description"></span>
              </div>
            </div>
          </van-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      // websiteInfo: [],
      isLoading: false,
      selectedPromotion: null,
      promotions: [
        {
          title: "မန်ဘာသစ် 200% ဘောနပ်စ်",
          description: `✅ 10,000 + 20,000 = 30,000 * 15 ဆ = 450,000 ကစားမှတ် ပြည့်အောင်ကစားပေးရမည်။<br><br> ✅ ( သွင်းငွေ+ဘောနပ်) ၏ 10 ဆ အနိုင်ယူနစ်ထုတ်ယူနိုင်ပါသည်။ (လက်ကျန်ယူနစ်များအား ဆာဗာမှ ပြန်လည်သိမ်းယူသွားပါမည်) <br><br>✅ စလော့ဂိမ်းတခုထဲသာလျှင်ကစားရမည်။ <br><br>✅ တစ်ခြားသောဂိမ်းများကစားထားခြင်းတွေ့ရှိပါက အနိုင်ငွေအားလုံးဝထုတ်ပေးမည်မဟုတ်ပါ။`,
          image: "https://storage.googleapis.com/spacetech2/syy/welcome_200%25.webp",
        },
        {
          title: "သွင်းတိုင်းရ 10% ဘောနပ်စ်",
          image: "https://storage.googleapis.com/spacetech2/syy/deposit_10%25.webp",
          description: `✅ သွင်းငွေ 5000  ကျပ်မှစ ပြီး ရယူနိုင်ပါသည်။ ( အကြိမ်ရေ ကန့်သတ်ထားခြင်းမရှိပါ) <br><br> ✅ (ဘောနပ် + သွင်းငွေ ) 3 ဆ မှစပြီး ထုတ်ယူနိုင်ပါသည်။ <br><br> ✅ စလော့ဂိမ်းတစ်မျိုးတည်းသာ ကစားခွင့်ရှိပါသည်။ <br><br> ❌ စည်းကမ်းချက် မလိုက်နာပါက အလျော်အစားမလုပ်ပေးပါ❌`,
        },
        {
          title: "နေ့စဉ် ရှုံးကြေး 10% ဘောနပ်စ်",
          image: "https://storage.googleapis.com/spacetech2/syy/loss_10%25.webp",
          description: `✅ တစ်ရက်တာ အတွင်း ရှုံးငွေ၏  10% ကို ဘောနပ် ခံစားခွင့်ရှိပါသည်။ <br><br> ✅ နေ့စဉ် ရှုံးကြေးရယူပြီးသော ကစားသူများအနေဖြင့် ရှုံးကြေး၏ 10ဆ ကစားပြီးမှသာလျှင် အနိုင်ငွေကို ရရှိထားသော ရှုံးကြေးငွေ၏ 3 ဆ ကိုသာထုတ်ယူနိုင်သည်။ <br><br> ✅ ကျန်ယူနစ်များကို ဆာဗာမှအော်တိုနုတ်ယူသွားမည်ဖြစ်သည် (မှတ်ချက်- နေ့စဉ်ရှုံးကြေးဘောနပ်စ်အားထိုနေ့ည ၁၂ နာရီမှ ည ၁ နာရီအတွင်းသာလာရောက်ထုတ်ယူနိုင်ပါသည်ရှင့်။)`,
        },
        {
          title: "သူငယ်ချင်း မိတ်ဆက်ဘောနပ်",
          image: "https://storage.googleapis.com/spacetech2/syy/welcome_20%25.webp",
          description: `✅ သူငယ်ချင်းသွင်းငွေ ရဲ့ 20% ခံစားခွင့်ရှိပါသည်။ <br><br> ⛔ အထက်ပါဘောနပ်စ်ရရှိငွေအား စလော့တမျိုးထဲသာဆော့ကစားပေးရပါမည်။ အနိုင်ရရှိငွေ အားဘောနပ်စ်ရရှိငွေ၏ 10 ဆအထိရရှိအနိုင်ရအောင်ဆော့ကစားရမည်ဖြစ်ပြီး၊ ဘောနပ်စ်ရရှိငွေ၏ 3 ဆအားထုတ်ယူနိုင်မှာဖြစ်ပါတယ်ရှင့်။ ထိုအနိုင်‌ငွေအား ချက်ချင်း ထုတ်ယူပေးပါရှင့်။ <br><br> ❌ စည်းကမ်းချက်များအတိုင်းမလိုက်နာပါက အကောင့်ထဲရှိယူနစ်များအားပြန်လည်သိမ်းယူသွားပါမည်ရှင့်။ ❌`,
        },
        // {
        //   title: 'Birthday Bonus 20,000 MMK',
        //   image: 'https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/banner5.jpg',
        //   description: `► ဤပရိုမိုးရှင်းကို မန်ဘာဝင်တိုင်း တစ်နှစ် တစ်ကြိမ်ရယူနိုင်ပါသည်။ <br><br> ► ၎င်းပရိုမိုးရှင်းအား ရယူရန် Customer Service သို့ဆက်သွယ်ရပါမည်။ <br><br> ► မန်ဘာဝင်တိုင်းသည် တစ်ပတ်လျှင် 20,000 Ks အထက် အပတ်စဉ် 4 ပတ်ဆက်တိုက်ရှိရမည်။ <br><br> ► သင်၏ ID ကတ်ကို စစ်ဆေးရန် customer service ထံပုံရိုက်ပြရမည်။ <br><br> ► ဘောနပ်စ် 20,000Ks ( 09:00 - 21:00 ) တွင်ထုတ်ပေးမည်။ <br><br> ► TurnOver 1 ဆ ပြုလုပ်ရမည်။ ► ဤပရိုမိုးရှင်းသည် ဂိမ်းများအားလုံးကိုကစားနိုင်ပါသည်။ <br><br> ⚠️ မှတ်ချက် ⚠️ <br><br> • ဤပရိုမိုးရှင်းကို Salmon မှကြိုတင်အသိပေးခြင်းမရှိဘဲအချိန်မရွေးပြောင်းလဲနိုင်ပါသည်။ <br><br> • ဤပရိုမိုးရှင်းအား တစ်စုံတစ်ရာ အငြင်းပွားဖွယ်ရှိပါက Salmon ၏ဆုံးဖြတ်ချက်သာ အတည်ဖြစ်သည်။`,
        // },
      ],
    };
  },
  methods: {
    promotionIndex(index) {
      this.selectedPromotion = index;
    },
    // async fetchWebsiteData() {
    //   try {
    //     const res = await axios.get('/website-infos');
    //     this.websiteInfo = res.data.data[0];
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    // await this.fetchWebsiteData();
    // this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped>
.detail-button {
  appearance: none;
  /* background-color: transparent; */
  background: #ff0000;
  border: none;
  text-transform: uppercase;
  border-radius: 14px;
  box-sizing: border-box;
  color: #fff !important;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 1px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background: #2b2c2e;
  /* box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px; */
  transform: translateY(-2px);
  /* border: black !important; */
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
  /* border: black !important; */
  background: #2b2c2e;
}

.animate-charcter {
  text-transform: uppercase;
  background-image: linear-gradient(
    -225deg,
    #b50200 0%,
    #f3e706 29%,
    #b50200 67%,
    #f3e706 100%
  );
  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
  /* font-size: 190px; */
}

@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
</style>
